import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "../lib/smooth";

export default function StickyCTA() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let pastHero = false;
        let followVisible = false;
        const update = () => setVisible(pastHero && !followVisible);
        const onScroll = () => {
            pastHero = window.scrollY > window.innerHeight * 0.65;
            update();
        };
        const io = new IntersectionObserver(
            ([entry]) => {
                followVisible = entry.isIntersecting;
                update();
            },
            { threshold: 0.08 }
        );
        const follow = document.getElementById("follow");
        if (follow) io.observe(follow);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => {
            window.removeEventListener("scroll", onScroll);
            io.disconnect();
        };
    }, []);

    return (
        <div
            data-testid="sticky-cta-bar"
            aria-hidden={!visible}
            className={`fixed bottom-0 inset-x-0 z-40 transition-opacity duration-300 ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
            <button
                type="button"
                data-testid="sticky-cta-btn"
                tabIndex={visible ? 0 : -1}
                onClick={() => scrollToId("follow")}
                className="w-full bg-rose/95 backdrop-blur border-t border-honeysuckle/40 py-3 px-5 inline-flex items-center justify-center gap-2 text-[11px] md:text-xs uppercase tracking-[0.18em] text-blush hover:bg-honeysuckle hover:text-garden transition-colors duration-300"
            >
                Get the full song — it’s free
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </button>
        </div>
    );
}
